// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f3e47275","214":"34245a42","223":"cf6d51de","243":"af75594c","527":"cf153326","664":"bf33d0ed","732":"590e31ef","734":"84e79f17","746":"9a6985fa","779":"5d9080c4","964":"9db5d26a"}[chunkId] + ".chunk.js";
};